import { render, staticRenderFns } from "./DataCardList.vue?vue&type=template&id=fa55d1c6&scoped=true&"
import script from "./DataCardList.vue?vue&type=script&lang=js&"
export * from "./DataCardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa55d1c6",
  null
  
)

export default component.exports